import Vue from 'vue'

export const productService = {
  get,
  getLanguages,
  fetch,
  fetchAll,
  fetchAllPickupPoints,
  fetchPickupPoints,
  fetchShippingPrice,
  fetchShippingPrices,
  fetchDistributors,
  fetchPublishers,
  create,
  updateProduct,
  updateStock
}

function get (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product/' + id))
      .then(response => {
        let product = response.data.data
        processProduct(product)
        resolve(product)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getLanguages () {
  return ['nl', 'de', 'fr', 'en']
}

function fetch (filter) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product'), filter)
      .then(response => {
        let products = response.data.data
        products.forEach(function (product) {
          processProduct(product)
        })
        resolve(products)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchAll (page, size, search, distributorId, publisher, order) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-all'), {
      page: page,
      search: search,
      size: size,
      distributorId: distributorId,
      publisher: publisher,
      order: order
    })
      .then(response => {
        let products = response.data.data
        products.forEach(function (product) {
          processProduct(product)
        })
        resolve(products)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchAllPickupPoints () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-all-pickup'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchPickupPoints () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-pickup'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchShippingPrice (country) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-shipping'), {
      country: country
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchShippingPrices () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-shipping'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchDistributors () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-distributor'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchPublishers () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-publisher'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function create (product) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-create'), product)
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updateProduct (id, data) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-edit/' + id), data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updateStock (id, stock) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-stock/' + id), {
      stock: stock
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function processProduct (product) {
  if (product.language && product.language.length > 0) {
    if (!(product.language.length === 1 && product.language[0] === 'en')) {
      product.name = product.name + ' (' + product.language.join('/').toUpperCase() + ')'
    }
  }
  product.image = Vue.prototype.$hostname.concat('/image/product/').concat(product.id).concat('/').concat(product.image)
  product.price = parseFloat(Vue.options.filters.round(product.price, 2))
}



// WEBPACK FOOTER //
// ./src/services/product.service.js